import { Box, Typography, alpha, styled } from "@mui/material";
import { TreeItem, treeItemClasses } from "@mui/lab";

interface ITreeItemProps {
    nodeId: string;
    labelText: string;
    children?: any;
    disabled?: boolean;
    extraLabel?: React.ReactElement;
}

const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
    [`& .${treeItemClasses.group}`]: {
        marginLeft: 15,
        paddingLeft: 18,
        borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.2)}`,
        [`& .${treeItemClasses.content}`]: {
            paddingLeft: theme.spacing(2),
        },
    },
}));

const StyledTreeItem = (props: ITreeItemProps) => {
    const { labelText, nodeId, children, disabled, extraLabel } = props;

    return (
        <StyledTreeItemRoot
            role={"tree-item-" + nodeId}
            disabled={disabled}
            label={
                <Box sx={{ height: 50, display: "flex", alignItems: "center" }}>
                    <Typography sx={{ flexGrow: 1 }}>{labelText}</Typography>
                    {extraLabel}
                </Box>
            }
            nodeId={nodeId}
            children={children}
        />
    );
};

export default StyledTreeItem;
